import gsap from 'gsap';
import * as PIXI from 'pixi.js';
import tinycolor from '../loaders/tinycolor2';
import Animator from '../utils/Animator';
import Container from '../utils/Container';
import Color from '../utils/Color';

export default class Preset extends Container {
  duration = 0;
  primaryColor = Color.WHITE;

  /**
   * @param app {PIXI.Application}
   */
  constructor({ app, isFullScreen = false, requiresRootTransform = false }) {
    super(app);

    this.model = {};
    this.isFullScreen = isFullScreen;
    this.requiresRootTransform = requiresRootTransform;

    this.timeline = gsap.timeline();

    this.root = new PIXI.Sprite();
    this.graphics = new PIXI.Graphics();

    this.container.addChild(this.graphics, this.root);
  }

  /**
   * @param item
   * @returns {Animator}
   */
  animate(item) {
    return new Animator(item, this.timeline);
  }

  setRoot({
    height = 0,
    width = 0,
    horizontal = 'center',
    vertical = 'center',
    anchorX = 0,
    anchorY = 0,
  }) {
    this.root.height = height;
    this.root.width = width;

    this.root.anchor = {
      x: anchorX,
      y: anchorY,
    };

    if (this.requiresRootTransform) {
      this.root.x = -this.root.width / 2;
      this.root.y = -this.root.height / 2;
      this.container.x = this.root.width / 2;
      this.container.y = this.root.height / 2;
    } else {
      const { x: anchoredX, y: anchoredY } = this.getAbsolutePosition(
        this.root,
        { horizontal, vertical }
      );
      this.container.x = anchoredX;
      this.container.y = anchoredY;
    }
  }

  update(model, rootConfigs = {}) {
    this.model = model;
    this.duration = model.duration;
    this.timeline.clear();
    this.timeline.addLabel('end', this.duration);
    this.primaryColor = tinycolor(model.primaryColor);

    // Reset the container position
    this.container.scale.x = 1;
    this.container.scale.y = 1;
    this.container.zIndex = model.zIndex;

    const anchorX =
      rootConfigs.anchorX ?? model.anchor?.x ?? this.root.anchor.x;
    const anchorY =
      rootConfigs.anchorY ?? model.anchor?.y ?? this.root.anchor.x;
    const horizontal =
      rootConfigs.positionX ?? model.position?.x ?? this.position?.x;
    const vertical =
      rootConfigs.positionY ?? model.position?.y ?? this.position?.y;
    const height =
      (this.isFullScreen ? this.app.screen.height : rootConfigs.height) ??
      this.root.height;
    const width =
      (this.isFullScreen ? this.app.screen.width : rootConfigs.width) ??
      this.root.width;
    this.setRoot({ height, width, horizontal, vertical, anchorX, anchorY });
  }

  render() {
    this.graphics.clear();
  }
}
